<template>
  <a
    class="news-item"
    :href="item ? item.slug : ''"
    target="_blank"
    @click="handleClick"
  >
    <AppCard class="news-item__card">
      <div class="news-item__media-container">
        <AppSkeleton v-if="loading" height="257px" width="100%" />
        <CardMedia
          v-else
          class="news-item__media"
          :src="item.media.imageEssence"
          :title="item.media.title"
          :alt="item.media.description"
          height="257"
        />
      </div>
      <div class="news-item__content">
        <div class="news-item__title">
          <AppSkeleton v-if="loading" width="90%" />
          <span v-else>{{ item.title }}</span>
        </div>
        <div v-if="loading || content" class="news-item__text">
          <template v-if="loading">
            <AppSkeleton width="75%" />
            <AppSkeleton width="60%" />
          </template>
          <span v-else>{{ item.standfirst }}</span>
        </div>
      </div>
    </AppCard>
  </a>
</template>

<script>
export default {
  name: "NewsWidgetItem",

  props: {
    item: {
      type: Object,
      required: false
    }
  },

  computed: {
    loading() {
      return !this.item;
    },
    content() {
      const { item } = this;
      let result = "";
      if (!item) return result;
      switch (item.type) {
        // case "video":
        //   result = item.subHeading;
        //   break;
        default:
          result = item.standfirst;
      }
      return result;
    }
  },

  methods: {
    handleClick(event) {
      if (!this.item) event.preventDefault();
    }
  }
};
</script>

<style lang="scss">
$p: ".news-item";

.news-item {
  margin-bottom: 20px;
  display: block;

  &:hover {
    text-decoration: none;
    #{$p}__media {
      transform: scale(1.05);
    }
  }

  &__media-container {
    position: relative;
    overflow: hidden;

    &:after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 30px;
      background: url("~@/assets/images/news/news-photo-bg.png") center bottom;
    }
  }

  &__content {
    padding: 15px 20px 25px;
  }

  &__media {
    transition: transform 0.6s cubic-bezier(0.35, 0, 0, 1);
  }

  &__title {
    font-weight: fw(bold);
    font-size: 21px;
    line-height: 1.2;
    color: colors(text-2);
  }

  &__text {
    @include multi-ellipsis(14, 21, 3);
    font-size: 14px;
    line-height: 21px;
    font-weight: fw(medium);
    margin: 20px 0;
  }

  &__tag {
    font-weight: 900;
    text-transform: uppercase;
    font-size: 12px;
  }
}
</style>
